"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTA_TEXTS_PER_FEATURE = exports.FEATURE_POSSIBLE_VIEWS = exports.URLS = exports.INTG_PASSIVE = exports.INTG = exports.SANDBOX_PASSIVE = exports.SANDBOX = exports.QA_PASSIVE = exports.QA = exports.DEV = exports.MISSING_PARENT_ELEMENT = exports.MISSING_PARENT_SELECTOR = exports.MISSING_URL = exports.OUTGOING_MESSAGES = exports.INCOMING_MESSAGES = void 0;
var enums_1 = require("./enums");
var MESSAGE_PREFIX = 'PREVIEW';
exports.INCOMING_MESSAGES = {
    INITIALIZE: MESSAGE_PREFIX + "_INITIALIZE",
    ON_LOAD: MESSAGE_PREFIX + "_ON_LOAD",
    ON_RESIZE: MESSAGE_PREFIX + "_ON_RESIZE",
    AVAILABLE_CATEGORIES: MESSAGE_PREFIX + "_AVAILABLE_CATEGORIES",
    AVAILABLE_VIEWS: MESSAGE_PREFIX + "_AVAILABLE_VIEWS",
    SET_CARD_DETAILS: MESSAGE_PREFIX + "_SET_CARD_DETAILS",
    ON_SELECT_CATEGORY: MESSAGE_PREFIX + "_ON_SELECT_CATEGORY",
    ON_DEMO_CREATE_PAYMENT: MESSAGE_PREFIX + "_ON_DEMO_CREATE_PAYMENT",
    ON_DEMO_DIGITAL_WALLET: MESSAGE_PREFIX + "_ON_DEMO_DIGITAL_WALLET",
    ON_SELECT_CARD_FIELD: MESSAGE_PREFIX + "_ON_SELECT_CARD_FIELD",
};
exports.OUTGOING_MESSAGES = {
    INITIALIZE: MESSAGE_PREFIX + "_INITIALIZE",
    PARAMS: MESSAGE_PREFIX + "_PARAMS",
    AVAILABLE_CATEGORIES: MESSAGE_PREFIX + "_AVAILABLE_CATEGORIES",
    AVAILABLE_VIEWS: MESSAGE_PREFIX + "_AVAILABLE_VIEWS",
    CTA_TEXTS: MESSAGE_PREFIX + "_CTA_TEXTS",
    SET_CARD_DETAILS: MESSAGE_PREFIX + "_SET_CARD_DETAILS"
};
exports.MISSING_URL = 'MISSING_URL';
exports.MISSING_PARENT_SELECTOR = 'MISSING_PARENT_SELECTOR';
exports.MISSING_PARENT_ELEMENT = 'MISSING_PARENT_ELEMENT';
exports.DEV = 'http://localhost:3000';
exports.QA = 'https://qacheckout.rapyd.net';
exports.QA_PASSIVE = 'https://qacheckout-preview.rapyd.net';
exports.SANDBOX = 'https://sandboxcheckout.rapyd.net';
exports.SANDBOX_PASSIVE = 'https://sandboxcheckout-preview.rapyd.net';
exports.INTG = 'https://intgcheckout.rapyd.net';
exports.INTG_PASSIVE = 'https://intgcheckout-preview.rapyd.net';
exports.URLS = {
    development: exports.DEV,
    qa: exports.QA,
    qa_passive: exports.QA_PASSIVE,
    sandbox: exports.SANDBOX,
    sandbox_passive: exports.SANDBOX_PASSIVE,
    intg: exports.INTG,
    intg_passive: exports.INTG_PASSIVE,
};
exports.FEATURE_POSSIBLE_VIEWS = (_a = {},
    _a[enums_1.FEATURE_TYPES.Checkout] = [enums_1.VIEWS.Desktop, enums_1.VIEWS.Mobile, enums_1.VIEWS.Sdk],
    _a[enums_1.FEATURE_TYPES.CardTokenization] = [enums_1.VIEWS.Desktop, enums_1.VIEWS.Mobile],
    _a[enums_1.FEATURE_TYPES.BeneficiaryTokenization] = [enums_1.VIEWS.Desktop, enums_1.VIEWS.Mobile],
    _a[enums_1.FEATURE_TYPES.Subscription] = [enums_1.VIEWS.Desktop, enums_1.VIEWS.Mobile],
    _a[enums_1.FEATURE_TYPES.Idv] = [enums_1.VIEWS.Desktop, enums_1.VIEWS.Mobile],
    _a[enums_1.FEATURE_TYPES.ReusableLink] = [enums_1.VIEWS.Desktop, enums_1.VIEWS.Mobile],
    _a);
exports.CTA_TEXTS_PER_FEATURE = (_b = {},
    _b[enums_1.FEATURE_TYPES.Checkout] = [
        enums_1.CTA_TEXTS.PLACE_YOUR_ORDER,
        enums_1.CTA_TEXTS.PAY_NOW,
        enums_1.CTA_TEXTS.MAKE_PAYMENT,
        enums_1.CTA_TEXTS.BUY,
        enums_1.CTA_TEXTS.DONATE,
        enums_1.CTA_TEXTS.PAY,
        enums_1.CTA_TEXTS.PURCHASE,
    ],
    _b[enums_1.FEATURE_TYPES.CardTokenization] = [enums_1.CTA_TEXTS.SAVE],
    _b[enums_1.FEATURE_TYPES.BeneficiaryTokenization] = [enums_1.CTA_TEXTS.SAVE],
    _b[enums_1.FEATURE_TYPES.Subscription] = [
        enums_1.CTA_TEXTS.START_TRIAL,
        enums_1.CTA_TEXTS.SUBSCRIBE,
        enums_1.CTA_TEXTS.PAY,
        enums_1.CTA_TEXTS.PURCHASE,
    ],
    _b[enums_1.FEATURE_TYPES.Idv] = [enums_1.CTA_TEXTS.START_VERIFICATION],
    _b[enums_1.FEATURE_TYPES.ReusableLink] = [enums_1.CTA_TEXTS.PROCEED_TO_PAYMENT],
    _b);
